import {
    IIndustryResponse,
    IIndustryUpdateRequest,
    IndustryUpdateRequest,
} from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';

function createUpdateResponse(industry: IIndustryResponse): IIndustryUpdateRequest {
    return {
        Name: industry.Name,
    };
}

export async function updateIndustry(
    industry: IIndustryResponse,
    updates: Partial<IIndustryUpdateRequest>,
) {
    const initialValue = createUpdateResponse(industry);
    return sdClient.updateIndustry({
        id: industry.Id,
        body: new IndustryUpdateRequest({ ...initialValue, ...updates }),
    });
}
